export default "__VITE_ASSET__yKt7NNQ9__"